export class Email {
  from: string
  replyTo: string
  to: string | []
  toUids: []
  cc: string | []
  ccUids: []
  bcc: string | []
  bccUids: []
  headers: {}
  message: {
    subject: string;
    html: string;
    attachments: any[];
  }

  template: {
    name: string;
    data: {};
  }

  constructor () {
    this.to = []
    this.message = {
      subject: '',
      html: '',
      attachments: []
    }
  }
}
